import { render } from "./ImageGaleryView.vue?vue&type=template&id=1f10db6d"
import script from "./ImageGaleryView.vue?vue&type=script&lang=js"
export * from "./ImageGaleryView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__